import { PreloaderService } from './../common/services/preloader/preloader.service';
import { AppInjector } from './../app-injector';
import { call, put, takeEvery, takeLatest, fork, select } from 'redux-saga/effects';

import main from '../components/main.saga';
import invetory from '../components/inventory/inventory.saga';
import location from '../components/location/location.saga';
import destination from '../components/destination/destination.saga';
import auth from '../components/auth/auth.saga';
import product from '../components/product/product.saga';
import customer from '../components/customer/customer.saga';
import order from '../components/order/order.saga';
import category from '../components/category/category.saga';
import size from './../components/size/size.saga';
import designer from './../components/designer/designer.saga';
import style from './../components/style/style.saga';
import status from './../components/status/status.saga';
import condition from './../components/condition/condition.saga';
import collection from './../components/collection/collection.saga';
import processType from './../components/process-types/process-types.saga';
import processStatus from './../components/process-status/process-status.saga';
import currencySaga from './../components/currency/currency.saga';
import courierSaga from './../components/courier/courier.saga';
import processTransition from './../components/process-transition/process-transition.saga';
import { API_CALL_ERROR, SETUP_CURRENCY_REQUESTED, SETUP_CURRENCY_SUCCEEDED } from './action';
import { NotificationService } from '../common/services/notification/notification.service';
import aclSaga from '../components/acl/acl.saga';
import userSaga from '../components/user/user.saga';
import constantSaga from './constant/constant.saga';
import provider from './../components/provider/provider.saga';
import printSaga from './print/print.saga';
import downloadSaga from './download/download.saga';
import colorSaga from './../components/color/color.saga';
import wardrobeSaga from './../components/wardrobe/wardrobe.saga';
import deliverySaga from './../components/delivery/delivery.saga';
import paymentSaga from './../components/payment/payment.saga';
import couponSaga from './../components/coupon/coupon.saga';
import shipmentSaga from './../components/shipment/shipment.saga';
import cartruleSaga from './../components/cartrule/cartrule.saga';
import processStatusGroupSaga from './../components/process-status-group/process-status-group.saga';
import customAttributeSaga from './../components/custom-attribute/custom-attribute.saga';
import customAttributeOptionSaga from './../components/custom-attribute-option/custom-attribute-option.saga';
import { ApiService } from '../api/api.service';
import { capitalize } from 'lodash';

function* watchApiCallError() {
  yield takeEvery(API_CALL_ERROR, function* (action) {
    AppInjector.get(PreloaderService).hide();
    console.log((action as any).error.error);
    if ((action as any).error !== undefined) {
      if ((action as any).error.error && (action as any).error.error.error_code === '124112'){
       return AppInjector.get(NotificationService).show('warning', `${capitalize((action as any).error.error.field)} in default address is invalid. Please update!`, 5000);
      }
      if ((action as any).error.error !== undefined && (action as any).error.error.message !== undefined) {
        AppInjector.get(NotificationService).show('warning', (action as any).error.error.message, 5000);
      }
    }
  });
}

function* watchFetchAllCurrenciesRequest() {
  yield takeEvery(SETUP_CURRENCY_REQUESTED, function* (action: any) {
    const currency = yield select((state: any) => state.RootReducer.attributes.currency);
    if (currency.fetched) {
      return false;
    }
    try {
      const api = AppInjector.get(ApiService);
      const result = yield api.currency.list().toPromise();
      const defaultCurrency = result.find((s) => s.base);
      localStorage.setItem('currency', defaultCurrency.code);
      yield put({
        type: SETUP_CURRENCY_SUCCEEDED,
        data: {
          currencies: result,
          selected_currency: defaultCurrency
        }
      });
    } catch (e) {
      yield put({ type: API_CALL_ERROR, error: e });
    }
  });
}


const RootSaga = [watchApiCallError, watchFetchAllCurrenciesRequest];

export default function* sagas() {
  yield [
    ...RootSaga.map(item => fork(item)),
    ...customAttributeOptionSaga,
    ...customAttributeSaga,
    ...processStatusGroupSaga,
    ...cartruleSaga,
    ...couponSaga,
    ...wardrobeSaga,
    ...colorSaga,
    ...main,
    ...invetory,
    ...location,
    ...destination,
    ...auth,
    ...product,
    ...customer,
    ...order,
    ...shipmentSaga,
    ...size,
    ...designer,
    ...category,
    ...style,
    ...status,
    ...condition,
    ...collection,
    ...processType,
    ...processStatus,
    ...processTransition,
    ...aclSaga,
    ...constantSaga,
    ...provider,
    ...userSaga,
    ...printSaga,
    ...currencySaga,
    ...courierSaga,
    ...downloadSaga,
    ...deliverySaga,
    ...paymentSaga
  ];
}
